import { render, staticRenderFns } from "./practiceBase.vue?vue&type=template&id=0e1fc336&scoped=true"
import script from "./practiceBase.vue?vue&type=script&lang=js"
export * from "./practiceBase.vue?vue&type=script&lang=js"
import style0 from "./practiceBase.vue?vue&type=style&index=0&id=0e1fc336&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fc336",
  null
  
)

export default component.exports